import { LoaderCircle } from 'lucide-react'
import { cn } from '../cn'

export interface SpinnerProps {
  className?: string
  /** Accessible label. Omit when the spinner sits inside a control that already says it is busy. */
  label?: string
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <LoaderCircle
      className={cn('size-4 shrink-0 animate-spin', className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  )
}
